import React from "react";
import cx from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import Close from "rialto-icons/Close";
import Delete from "rialto-icons/DeleteText";

import styles from "./DateTimeHeader.css";

const DateTimeHeader = ({ date, isLarge, onClose, onReset, title }) => {
  const button = (
    <button
      className={cx(styles.reset, { [styles.hidden]: !date })}
      onClick={onReset}
      type="button"
    >
      <Delete />
    </button>
  );

  return (
    <div className={styles.root}>
      <div className={styles.date}>
        {date ? moment(date).format(`${isLarge ? "dddd" : ""} D MMMM YYYY`) : title}
      </div>
      {button}
      <button className={styles.close} onClick={onClose}>
        <Close size="xs" />
      </button>
    </div>
  );
};

DateTimeHeader.propTypes = {
  date: PropTypes.instanceOf(Date),
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isLarge: PropTypes.bool,
};

export default DateTimeHeader;
